import React from 'react';
import styled from 'styled-components';

import { Icon } from '@ui/icons/Icon.tsx';

import { SEARCH_RESULTS_CONTAINER_ID } from './constants.ts';
import type { TranslateFn } from './types.ts';

type NoSearchResultsProps = {
  $isDesktop?: boolean;
};

type NoSearchResultsWidgetProps = {
  isDesktop?: boolean;
  T: TranslateFn;
};

const NoSearchResults = styled.li<NoSearchResultsProps>`
  padding: 18px 12px 20px;
  position: relative;
  margin: 0;
  display: flex;
  flex-direction: row;
  align-items: baseline;
  height: ${({ $isDesktop }) => ($isDesktop ? 'auto' : '100vh')};
`;

const IconWrapper = styled.div`
  vertical-align: middle;
`;

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Labels = styled.div`
  margin-inline-start: 12px;

  span {
    display: block;
  }

  .label {
    display: block;
    color: #333;
    ${({ theme }) => theme.fontSize('16px')};
    font-weight: 500;
    line-height: 150%;
  }

  .info {
    color: #666;
    ${({ theme }) => theme.fontSize('14px')};
    font-weight: 400;
    line-height: 18px;
  }
`;

const NoSearchResultsWidget = ({ isDesktop, T }: NoSearchResultsWidgetProps) => (
  <NoSearchResults data-testid="noSearchResultsWidget" $isDesktop={isDesktop} id={SEARCH_RESULTS_CONTAINER_ID}>
    <ContentWrapper>
      <IconWrapper>
        <Icon name="no-results" cdn fillColor="#666666" width={40} height={40} />
      </IconWrapper>
      <Labels>
        <span className="label">{T('ui:Sorry, no matches were found')}</span>
        <span className="info">{T('ui:Try searching a different phrase')}</span>
      </Labels>
    </ContentWrapper>
  </NoSearchResults>
);

export default NoSearchResultsWidget;
